import { useEffect, useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import {
  applyPreferredLocale,
  getPreferredLocale,
  LOCALE_OPTIONS,
  setPreferredLocale,
} from '@/services/locale.service';
import SettingsHeading from '@/shared-components/text/components/SettingsHeading';
import Text from '@/shared-components/text/components/Text';

import './index.css';

function LanguageOption({ label, code, isActive, onClick }) {
  return (
    <button
      type="button"
      className={`settings-language__option${isActive ? ' active' : ''}`}
      onClick={onClick}
    >
      <Text className="settings-language__option-text font-size-medium">
        {label}
      </Text>
      <Text className="settings-language__option-code font-size-small">
        {code.toUpperCase()}
      </Text>
    </button>
  );
}

export default function LanguageSettings() {
  const tLanguage = useTranslations('common.settings_menu.preferences.language_selector');
  const [selectedLocale, setSelectedLocale] = useState(() => getPreferredLocale());

  useEffect(() => {
    setSelectedLocale(applyPreferredLocale());
  }, []);

  useEffect(() => {
    const handlePreferredLanguageChange = (event) => {
      const nextLocale = event?.detail?.locale;
      if (nextLocale) {
        setSelectedLocale(nextLocale);
      }
    };

    window.addEventListener('suarte:preferred-language-changed', handlePreferredLanguageChange);
    return () => {
      window.removeEventListener('suarte:preferred-language-changed', handlePreferredLanguageChange);
    };
  }, []);

  return (
    <>
      <SettingsHeading text={tLanguage('label')} />

      <div className="settings-language__container">
        {LOCALE_OPTIONS.map((option) => {
          const isSelected = option.code === selectedLocale;
          return (
            <LanguageOption
              key={option.code}
              label={tLanguage(`options.${option.code}`)}
              code={option.code}
              isActive={isSelected}
              onClick={() => setSelectedLocale(setPreferredLocale(option.code))}
            />
          );
        })}
      </div>
    </>
  );
}
